import { CheckboxTogether } from 'react-together-ant-design'

export function AntDesignCheckboxTogetherDemo() {
  return (
    <div className='flex-col place-items-center'>
      <CheckboxTogether rtKey='checkbox-doc-demo' />
    </div>
  )
}
